import { buildError } from 'core/api/api-error';

const parseError = error => Promise.reject(buildError(error.response));

export default parseError;
